
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCapacitor01On as ObiCapacitor01OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-capacitor-01-on.js';
 
 
 

 
 export const ObiCapacitor01On = createComponent({
   react: React,
   tagName: 'obi-capacitor-01-on',
   elementClass: ObiCapacitor01OnElement,
   events: {
     
   }
  });
 
 